import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { acceptConsents, myConsents, withdrawBiometric } from "../api/consents";
import { LEGAL_VERSION } from "../features/legal/content";
import { isNative } from "../native/capacitor";

// حالة الموافقات الصريحة للمستخدم الحالي + تسجيل القبول أو سحب الموافقة الحيوية.
export const useConsents = () => {
  const { i18n } = useTranslation();
  const [state, setState] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    try {
      setState(await myConsents());
    } catch (err) {
      // فشل الشبكة/السيرفر: نُغلق الوصول احتياطاً (fail-closed) إلا في حالة انتهاء الجلسة.
      setState(err?.response?.status === 401 ? null : { blocked: true, missing: ["terms", "privacy", "eula"] });
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const accept = async (kinds) => {
    const platform = isNative() ? "mobile" : "web";
    setState(await acceptConsents(kinds, LEGAL_VERSION, i18n.language === "ar" ? "ar" : "en", platform));
  };

  const withdraw = async (reason) => setState(await withdrawBiometric(reason));

  return { state, loading, accept, withdraw, reload: load };
};
